<template>
	<div id="enterprise_detail">
		<leftnav class="fl" :title="companyinfor.title"></leftnav>
		<div class="index_left" :style="isCollapse?'margin-left: 0;width:100%':''">
			<govheader></govheader>
			<div class="index_left_centerpage" :data-type="userdata.userType">
				<div class="enterprise_detail">
					<div class="whitebox ">
						<div class="d_blocktitle">
							<i class="title-icon title-icon1"></i>
							<h3 class="ctitle">{{companyinfor.title}} </h3>
							<!-- <span :class="companyinfor.collectId == 0?'collectbtn add fr':'collectbtn remove fr'"
								@click="collectFun()">{{companyinfor.collectId == 0?'+添加关注':'取消关注'}}</span> 楼宇还没有收藏类型ID-->

						</div>
						<ul class="conpany-infor-new oh">
							<li class="inforLine inforLine-3"><span class="label">地址：</span><span
									class="infortext">{{companyinfor.address}}</span></li>
							<li class="inforLine inforLine-3"><span class="label">竣工时间：</span><span
									class="infortext">{{companyinfor.completionTime}}</span></li>
							<li class="inforLine inforLine-3"><span class="label">总建面：</span><span
									class="infortext">{{emptyStr(companyinfor.totalSize)}}</span></li>
							<li class="inforLine inforLine-3"><span class="label">楼盘类型：</span><span
									class="infortext">{{emptyStr(companyinfor.type)}}</span></li>
							<li class="inforLine inforLine-3"><span class="label">得房率：</span><span
									class="infortext">{{emptyStr(companyinfor.buildingSize)}}</span></li>
							<li class="inforLine inforLine-3"><span class="label">楼层：</span><span
									class="infortext">{{companyinfor.floor}}</span></li>
							<li class="inforLine inforLine-3"><span class="label">总停车位：</span><span
									class="infortext">{{companyinfor.parking}}</span></li>
							<li class="inforLine inforLine-3"><span class="label">电梯：</span><span
									class="infortext">{{companyinfor.elevator}}</span></li>
							<li class="inforLine inforLine-3"><span class="label">物业公司：</span><span
									class="infortext">{{companyinfor.property}}</span></li>
							<li class="inforLine inforLine-3"><span class="label">开发商：</span><span
									class="infortext">{{companyinfor.property}}</span></li>
							<li class="inforLine inforLine-3"><span class="label">物业费：</span><span
									class="infortext">{{emptyStr(companyinfor.propertyFees)}}</span></li>

							<li class="inforLine inforLine-3"><span class="label">车位月租金：</span><span
									class="infortext">{{emptyStr(companyinfor.rent)}}</span></li>

						</ul>
						<p class="companyinfor oneline">
							<i>楼宇简介：</i><em class="infortext" v-html="companyinfor.summary"> </em>
						</p>
					</div>
					<div class="de_floorlist1 ende_floorlist" style="width:100%">
						<div class="ende_floorlistfixed" :style="isCollapse?'width:100%;left:0':''">
							<ul class="oh">
								<li class="floorlistLi" @click="floorscroll(0)">迁址动态</li>
								<li class="floorlistLi" @click="floorscroll(1)">企业分布</li>
								<li class="floorlistLi" @click="floorscroll(2)">入驻企业</li>
							</ul>
						</div>
					</div>
					<!--  -->
					<div class="whitebox company-contact	">
						<div class=" d_blocktitle d-floortitle">
							<i class="title-icon title-icon6"></i>
							<h3 class="title">迁址动态</h3>
						</div>
						<ul class="oh conpany-infor-new w95mg">
							<li class="fl inforLine inforLine-2"><span class="label">在营企业数量：</span><span
									class="infortext">{{companyinfor.enterpriseNum}}家</span></li>
							<li class="fl inforLine inforLine-2"><span class="label">全年迁入企业：</span><span
									class="infortext">{{companyinfor.moveIn}}家</span></li>
							<li class="fl inforLine inforLine-2"><span class="label">上月迁入企业：</span><span
									class="infortext">{{companyinfor.lastMonthMoveIn}}家</span></li>
							<li class="fl inforLine inforLine-2"><span class="label">全年迁出企业：</span><span
									class="infortext">{{companyinfor.moveOut}}家</span></li>
							<li class="fl inforLine inforLine-2"><span class="label">上月迁出企业：</span><span
									class="infortext">{{companyinfor.lastMonthMoveOut}}家</span></li>
						</ul>
						<div class="condition_bar w95mg oh">
							<div :key="i" :class="i == 0 ? 'fl':'fr'" :style="'width:'+echartWidth2+'px;'"
								v-for="(list,i) in dynamicList">
								<div class="bd_dynamic_date oh">
									<div class="dyd_screen fl">
										<el-select v-model="list.screen_type" @change="yearToggleMonth(i)" class="m-2"
											placeholder="Select" size="small" style="width: 60px;">
											<el-option v-for="item in list.typelist" :key="item.value"
												:label="item.label" :value="item.value" />
										</el-select>
									</div>
									<div class="screen_year oh fl" v-show="list.screen_type == 'year'">
										<!--  :picker-options="beginDate(list.year_to)" :picker-options="processDate(list.year_from)"   -->
										<el-date-picker v-model="list.year_from"
											@change="dateChangFun(list,'year_from')" type="year" size="small"
											:clearable="false" style="width:130px;float:left" placeholder="开始年份" /><em
											class="fl" style="margin: 0 10px;">-</em>
										<el-date-picker v-model="list.year_to" @change="dateChangFun(list,'year_to')"
											type="year" size="small" :clearable="false" placeholder="结束年份"
											style="width: 130px;float:left" />
									</div>
									<!-- <div class="screen_month fl" v-show="list.screen_type == 'month'">
										<el-date-picker v-model="list.full_year" type="year" :picker-options="beginDate(list.full_year)" @change="dateChangFun(list,'full_year')" size="small" :clearable="false" style="width:130px;float:left" placeholder="选择年份"/> 
									</div> -->
								</div>
								<div class="echartbox echartboxCommon" :style="'width:'+echartWidth2+'px;'"
									:id="'condition_bar'+(i+1)"></div>
							</div>

						</div>
					</div>
					<!--  -->
					<div class="whitebox">
						<div class="d_blocktitle d-floortitle">
							<i class="title-icon title-icon3"></i>
							<h3 class="title">企业分布</h3>
						</div>
						<div class="condition_bar w95mg oh">
							<div class="fl">
								<div class="echartbox echartboxCommon" data-title="企业产业分布"
									:style="'width:'+echartWidth2+'px;'" id="condition_pie2"></div>
							</div>
							<div class="fr" v-show="extendData.tagList.length>0">
								<div class="echartbox echartboxCommon" data-title="企业类型分布"
									:style="'width:'+echartWidth2+'px;'" id="condition_pie1"></div>
							</div>
						</div>
					</div>
					<!--  -->
					<div class="whitebox company-investinfor"
						:style="enterpriselist.length==0 ? 'padding-bottom:120px;':''">
						<div class="d_blocktitle d-floortitle">
							<i class="title-icon"></i>
							<h3 class="title">入驻企业</h3>
						</div>
						<div class="opport-screen-list1 w95mg">
							<dl class="opport-screen bdbe" v-show="extendData.tagList.length>0">
								<dt class="fl">画像标签</dt>
								<dd class="fl">
									<span @click="tagcode=0;getEnterpriselist();"
										:class="0 == tagcode?'a-screen current' : 'a-screen'">全部<em class="num">({{tagNewList.total}})</em></span>
									<span :key="index" v-for="(item,index) in extendData.tagList"
									 @click="tagcode=item.tagCode;getEnterpriselist();"
										:class="item.tagCode == tagcode?'a-screen current' : 'a-screen'">{{item.label}}<em class="num">({{item.value}})</em></span>
										<span v-show="tagNewList.other>0" @click="tagcode='other';getEnterpriselist();" :class="'other' == tagcode?'a-screen current' : 'a-screen'">其他<em class="num">({{tagNewList.other}})</em></span>	
								</dd>
							</dl>
						</div>
						<table border="0" cellspacing="0" cellpadding="0" class="w95mg enterprise_table">
							<tr>
								<th class="xuhaotd">序号</th>
								<th>企业名称</th>
								<th>注册资本</th>
								<th>所属产业</th>
								<th>迁入时间</th>
								<th>详细地址</th>
							</tr>
							<tr :key="i" v-for="(list,i) in enterpriselist">
								<td>{{i+1}}</td>
								<td class="title">
									<span v-if="list.cylStockCode == ''"
										@click="routerlinkid('/enterpriseYq',list.stockCode)">{{list.title}}</span>
									<span v-if="list.cylStockCode != ''"
										@click="parkEnterpriseRouter(list.cylStockCode, list.stockCode)">{{list.title}}</span>
								</td>
								<td>{{list.regCapital}}</td>
								<td>{{list.industry}}</td>
								<td>{{list.moveInDate}}</td>
								<td>{{list.address}}</td>
							</tr>
						</table>
						<div class="centerpage1 company_pagelist" v-show="totalPage>1">
							<zpagenav v-bind:page="page" v-bind:page-size="pageSize" v-bind:total="total"
								v-bind:max-page="maxPage" v-on:pagehandler="pageHandler"></zpagenav>
						</div>
					</div>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
	import { mapState, mapMutations, mapGetters } from "vuex";

	export default {
		name: 'buildingDetail',
		computed: {
		...mapState({
			isCollapse: (state) => state.isCollapse,
		}),
		...mapGetters(['isCollapse'])
	},
		data() {
			return {
				title: '楼宇详情页',
				userdata: {},
				dynamicList: [{
						type: 1,
						name: "迁入企业",
						screen_type: "year",
						year_from: "2013",
						year_to: "2023",
						year_range: "2013-2023",
						full_year: "2023",
						full_year_ajax: "2023",
						typelist: [{
							value: "year",
							label: '年'
						}, {
							value: "month",
							label: '月'
						}],
						yearList: [],
						monthList: []
					},
					{
						type: 2,
						name: "迁出企业",
						screen_type: "year",
						year_from: "2013",
						year_to: "2023",
						year_range: "2013-2023",
						full_year: "2023",
						full_year_ajax: "2023",
						typelist: [{
							value: "year",
							label: '年'
						}, {
							value: "month",
							label: '月'
						}, ],
						yearList: [],
						monthList: []
					},
				],
				tagcode: 0,
				tagNewList:{total:0,other:0},
				otherNum:0,
				tagnum:0,
				startDatePicker: this.beginDate(2013),
				endDatePicker: this.processDate(2023),
				dateYearShortcut: {
					type: 'year',
					size: "default",
					clearable: false,
					style: "width:130px;float:left"
				},
				current_year: 2023,
				enterpriseid: 0,
				colors: ['#5E83CC', '#ffbb1c', '#47a59d', "#3975b8"],
				enterpriselist: [],
				companyinfor: {
					tag: "测试文字",
					name: "雪松大厦",
					collectId: 0,
					collectType: 20,
					num: 80,
				},
				extendData: {
					tagList: [],
				},
				echartWidth2: document.body.offsetWidth * 0.8728 * 0.95 * 0.48,
				investList: [],
				floorlist: ['联系方式', '投资领域', '投资事件'],
				barHeight: 60,
				rwebsite: false, // 机构网页跳转提示框
				page: 1, //显示的是哪一页
				haspage: true, //是否还有下一页
				pageSize: 10, //每一页显示的数据条数
				total: 0, //记录总数
				totalPage: 1,
				maxPage: 10, //最大页数   
			}
		},
		beforeCreate() {

		},
		created() {
			this.$nextTick(() => {
				// 禁用右键
				document.oncontextmenu = new Function("event.returnValue=false");
				// 禁用选择
				document.onselectstart = new Function("event.returnValue=false");
			});
			// window.scrollTo(0,0);
			this.bus.$emit('loading', true);
			this.enterpriseid = this.$route.query.id;
			var _this = this;
			this.userdata = this.getuseriformation();
			var nowdate = new Date();
			this.current_year = nowdate.getFullYear();
			for (var i = 0; i < this.dynamicList.length; i++) {
				this.dynamicList.full_year = nowdate.getFullYear();
				this.dynamicList.full_year_ajax = nowdate.getFullYear();
			}
			this.getPageDetail();
		},
		mounted() {
			window.scrollTo(0, 0);
			window.addEventListener("scroll", this.handleScroll, true);
		},
		methods: {
			//单独的判断跳转链
			parkEnterpriseRouter(clycode, pid) {
				let routeUrl = this.$router.resolve({
					path: '/enterprises',
					query: {
						id: clycode,
						pid: pid
					}
				});
				window.open(routeUrl.href, '_blank');
			},
			//切换年月类型时折线数据变换
			yearToggleMonth(index) {
				var curlist = this.dynamicList[index],
					lineData = [],
					lineType = 1;
				if (curlist.screen_type == 'year') {
					lineType = 1;
					lineData = curlist.yearList;
				} else {
					lineType = 2;
					lineData = curlist.monthList;
				}
				this.linechartfun('condition_bar' + (index + 1), lineData, curlist.name, lineType);
			},
			// 选择年份范围选择时开始时间不能大于结束时间，结束时间不能小于开始时间 
			// 提出开始时间必须小于提出结束时间
			beginDate(todate) {
				let self = this
				return {
					disabledDate(time) {
						if (self.yeartsEnd !== '') {
							let fixedTime = new Date(time)
							return fixedTime.getFullYear() > todate;
						}
					}
				}
			},
			// 提出结束时间必须大于提出开始时间
			processDate(fromdate) {
				let self = this
				return {
					disabledDate(time) {
						// let fixedTime = new Date(self.oldTime).getTime()
						// return time.getTime() < fixedTime
						let fixedTime = new Date(time);
						return fixedTime.getFullYear() < fromdate || fixedTime.getFullYear() > self.current_year
					}
				}
			},
			dateChangFun(list, type) {
				console.log(list.name, type);
				let listYearForm = list.yearList[0].date * 1;
				let listYearTo = list.yearList[list.yearList.length - 1].date * 1;
				if (type == 'year_from' || type == 'year_to') {
					let date1 = typeof(list.year_from) == 'object' ? list.year_from.getFullYear() : list.year_from;
					let date2 = typeof(list.year_to) == 'object' ? list.year_to.getFullYear() : list.year_to;
					date1 = date1 * 1;
					date2 = date2 * 1;
					if (date1 == listYearTo || date1 > listYearTo || date2 == listYearForm || date2 < listYearForm ||
						date1 == date2) {
						this.$message({
							type: 'error',
							message: '需要选择正确时间区间',
						});
						return;
					}

					if (date1 < listYearForm) {
						date1 = listYearForm;
					}
					if (date2 > listYearTo) {
						date2 = listYearTo;
					}
					var filterData = list.yearList.filter(tlist => {
						var datetime = tlist.date * 1;
						return (datetime > date1 || datetime == date1) && (datetime < date2 || datetime == date2);
					})
					list.year_range = date1 + '-' + date2;
					console.log(filterData);

					this.linechartfun('condition_bar' + list.type, filterData, list.name, 1);

				} else if (type == "full_year") {
					//月份使用的 已废弃
					list.full_year_ajax = list.full_year.getFullYear();
					console.log(list.full_year_ajax)
				}
			},
			//获取详情页信息
			getPageDetail() {
				var _this = this;
				this.$axios.get(this.$api.park.building.detail() + "?id=" + this.enterpriseid, {
					headers: {
						AuthToken: this.userdata.token
					}
				}).then(function(res) {
					// console.log(res.data)
					if (res.data.success) {
						console.log('getPageDetail', res.data);
						
						document.title = res.data.data.title;
						_this.companyinfor = res.data.data; //基础信息 
						_this.companyinfor.tag = 'aaaa'; //  
						_this.extendData = res.data.extend;
						_this.getEnterpriselist(1);
						// year_from:"2013",year_to:"2023",year_range:"2013-2023",
						_this.dynamicList[0].year_from = res.data.extend.moveInYearly[0].date;
						_this.dynamicList[0].year_to = res.data.extend.moveInYearly[res.data.extend.moveInYearly.length - 1].date;
						_this.dynamicList[0].year_range = res.data.extend.moveInYearly[0].date + '-' + res.data
							.extend.moveInYearly[res.data.extend.moveInYearly.length - 1].date;
						_this.dynamicList[0].yearList = res.data.extend.moveInYearly;
						_this.dynamicList[0].monthList = res.data.extend.moveInMonthly;
						_this.dynamicList[1].year_from = res.data.extend.moveOutYearly[0].date;
						_this.dynamicList[1].year_to = res.data.extend.moveOutYearly[res.data.extend.moveOutYearly.length - 1].date;
						_this.dynamicList[1].year_range = res.data.extend.moveOutYearly[0].date + '-' + res.data
							.extend.moveOutYearly[res.data.extend.moveOutYearly.length - 1].date;
						_this.dynamicList[1].yearList = res.data.extend.moveOutYearly;
						_this.dynamicList[1].monthList = res.data.extend.moveOutMonthly;
						setTimeout(function() {
							_this.linechartfun('condition_bar1', res.data.extend.moveInYearly, '迁入企业', 1);
							_this.linechartfun('condition_bar2', res.data.extend.moveOutYearly, '迁出企业', 1);
							_this.piefunOld('condition_pie1', res.data.extend.tagList, '优质企业类型分布')
							_this.piefunOld('condition_pie2', res.data.extend.industryList, '入驻企业产业分布');
						}, 2000);
						
						
					} else {
						_this.tokenfailed(res.data.msg);
					}
				}).catch(function(error) {
					// 请求失败处理 console.log(error);
				});
			},
			piefunOld(el, data, title) {
				if (data.length < 1) {
					return;
				}
				var mypiechart = echarts.init(document.getElementById(el));
				var tagnum=0;
				for (var i = 0; i < data.length; i++) {
					tagnum+=data[i].value;
					data[i].name = data[i].label;
				}
				this.tagnum=tagnum;
				var option = {
					title: {
						text: title,
						left: 'center',
						bottom: 10,
					},
					//悬浮显示
					tooltip: {
						trigger: 'item',
						formatter: function(params) {
							// console.log(params)
							let rethtml = params.marker + params.name + " : " + params.value + ' 家';
							return rethtml;
						},
					},
					// color: ['#5E83CC', '#ffbb1c', '#47a59d', "#f60", "#ff0", "#f87f8f"],
					//图例
					legend: {
						show: false,
						left: 'center',
						bottom: 10,
						itemWidth: 6,
						itemHeight: 6
					},

					series: [{
						name: '',
						type: 'pie',
						radius: '60%',
						data: data,
						label: {
							show: true,
							position: 'outside',
							color: '#000',
							fontSize: 12,
							formatter: '{b},{d}' + '%',
						},
						emphasis: {
							itemStyle: {
								shadowBlur: 10,
								shadowOffsetX: 0,
								shadowColor: 'rgba(0, 0, 0, 0.5)'
							}
						}
					}]
				};
				mypiechart.setOption(option);
			},
			linechartfun(el, serdata, title, type) {
				var mylinechart = echarts.init(document.getElementById(el));
				var xdata = [],
					ydata = [];
				// var serdata=this.lineReturnData(data,type,type1); 
				for (var n = 0; n < serdata.length; n++) {
					xdata.push(serdata[n].date);
					ydata.push(serdata[n].value);
				}
				var timeunit = type == 2 ? '月' : '年';
				// console.log(xdata,ydata); 
				var option = {
					title: {
						text: '',
						left: 'center',
						top: 10,
					},
					color: ['#5E83CC', '#ffbb1c', '#47a59d', "#f60", "#ff0", "#f87f8f"],
					// tooltip: {
					// 	trigger: 'item'
					// },
					tooltip: {
						trigger: 'item',
						backgroundColor: 'rgba(255,255,255,0.9)',
						borderColor: '#ddd',
						borderWidth: '1',
						textStyle: {
							color: '#000',
							fontSize: 14,
						},
						formatter: function(params) {
							let rethtml = params.marker + params.name + timeunit + title + "：" + params.value +
							'家';
							return rethtml;
						}
					},
					legend: {
						show: true,
						bottom: 10,
					},
					label: {
						show: true
					},
					xAxis: {
						type: 'category',
						data: xdata,
					},
					yAxis: {
						type: 'value',
						name: title + '（家）',
					},
					series: [{
						name: '',
						data: ydata,
						type: 'line',
						smooth: true
					}]
				};
				mylinechart.setOption(option);
			},
			pageHandler: function(page) {
				this.page = page;
				// console.log('pageHandler',this.userdata.groupType==0,page > 2)
				this.getEnterpriselist(page);
			},
			//获取入驻企业列表页
			getEnterpriselist(page) {
				var _this = this;
				this.bus.$emit('loading', true);
				var tagja = this.splicing('tag', this.tagcode);
				this.page = page ? page : 1;
				var ajaxurl = this.$api.park.building.enterpriselist() + "?id=" + this.enterpriseid + '&page=' + this
					.page + tagja;
				this.$axios.get(this.$api.park.building.enterpriselist() + "?id=" + this.enterpriseid + '&page=' + this
					.page + tagja, {
						headers: {
							AuthToken: this.userdata.token
						}
					}).then(function(res) {
					if (res.data.success) {
						console.log('获取入驻企业列表页', ajaxurl);
						_this.enterpriselist = res.data.list;
						_this.totalPage = res.data.totalPage;
						_this.pageSize = res.data.pageSize;
						_this.total = res.data.totalRecord; 
							if(_this.extendData.tagList.length>0 && _this.tagNewList.total == 0 && _this.total>0){
								_this.tagNewList.total=res.data.totalRecord;
								var aaa=0;
								_this.extendData.tagList.forEach(list=>{ 
									aaa=aaa+list.value; 
									console.log('tagList',list.value,aaa);
								})
								_this.tagNewList.other=_this.tagNewList.total-aaa;
								console.log(_this.total,_this.tagNewList);
							}
						// _this.otherNum=_this.total - _this.tagnum;
						_this.bus.$emit('loading', false);
					}
				}).catch(function(error) {
					// 请求失败处理 console.log(error);
				});
			},
			//企业网址跳转
			windowOpen(url) {
				window.open(url, "_blank");
			},
			//排序 从大到小
			sortKey(array, key) {
				return array.sort(function(a, b) {
					var x = a[key];
					var y = b[key];
					return ((x > y) ? -1 : (x < y) ? 1 : 0)
				})
			},

			//添加删除收藏
			collectFun() {
				// console.log(this.companyinfor.collectId,this.companyinfor);
				this.listToggleCollect(this.companyinfor, 'acoc');
			},
			//测试title的问题
			testFloorTitle() {
				console.log(document.getElementsByClassName('d-floortitle').length, document.getElementsByClassName(
					'floorlistLi').length)
				for (var i = 0; i < document.getElementsByClassName('d-floortitle').length; i++) {
					console.log(document.getElementsByClassName('d-floortitle')[i], document.getElementsByClassName(
						'floorlistLi')[i]);
				}
			},
			handleScroll: function(e) {
				var enflolength = document.getElementsByClassName('ende_floorlistfixed').length;
				// console.log('enflolength1',enflolength)
				if (enflolength < 1) {
					return;
				}
				var sctop = document.documentElement.scrollTop;
				var bartop = document.getElementsByClassName('ende_floorlist')[0].offsetTop;
				// console.log(sctop,bartop);
				if (sctop < bartop) {
					document.getElementsByClassName('ende_floorlistfixed')[0].className = "ende_floorlistfixed";
				} else {
					document.getElementsByClassName('ende_floorlistfixed')[0].className =
						"ende_floorlistfixed fixedbox";
					var lengtsd = document.getElementsByClassName('floorlistLi').length;
					// console.log(lengtsd,document.getElementsByClassName('d-floortitle').length )
					for (var i = 0; i < lengtsd; i++) {
						// console.log(document.getElementsByClassName('d-floortitle')[i],document.getElementsByClassName('d-floortitle')[i+1])
						var top1 = document.getElementsByClassName('d-floortitle')[i].offsetTop - this.barHeight;
						if (i < lengtsd - 1) {
							var top2 = document.getElementsByClassName('d-floortitle')[i + 1].offsetTop - 11 - this
								.barHeight;
							if (top1 > 0 && top2 > 0 && sctop > top1 && sctop < top2) {
								this.floorscroll(i, 'scroll');
							}
						} else if (i == lengtsd - 1) {
							if (top1 > 0 && sctop > top1) {
								this.floorscroll(i, 'scroll');
							}
						}
					};
				}
			},
			floorscroll(indexs, type) {
				// console.log(indexs,type);
				var oftop = document.getElementsByClassName('d-floortitle')[indexs].offsetTop - this.barHeight + 6;
				var lengtsd = document.getElementsByClassName('floorlistLi').length;
				// console.log('floorsrcoll',lengtsd);
				for (var i = 0; i < lengtsd; i++) {
					var classNameaf = "floorlistLi";
					if (i == indexs) {
						classNameaf = "floorlistLi current";
					}
					document.getElementsByClassName('floorlistLi')[i].className = classNameaf;
				}
				if (type != 'scroll') {
					// console.log('非',type,oftop);
					window.scrollTo(0, oftop);
				}
				if (type == 'test') {
					this.testFloorTitle();
					console.log(this.riskinfobtn, this.eqpledgeBtn)
				}
			},



			// handleScroll: function(e) {
			// 	var sctop = document.documentElement.scrollTop; 
			// }, 
			detailrouterto(path, id) {
				if (id == 0 || id == "") {
					return;
				}
				let routeUrl = this.$router.resolve({
					path: path,
					query: {
						id: id
					}
				});
				window.open(routeUrl.href, '_blank');
			},
		}
	}
</script>

<style>
</style>